import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type GlobalSearchStateMessage } from '../../../../data-access/types/GlobalSearchResponse'

interface IGlobalSearchEmptyStateProps {
  message?: Nullable<GlobalSearchStateMessage>
}

export const GlobalSearchEmptyState = ({
  message,
}: IGlobalSearchEmptyStateProps) => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='search'
      header={message?.title ?? intl.formatMessage(messages.header)}
      content={
        <Text>
          {message?.description ?? intl.formatMessage(messages.content)}
        </Text>
      }
    />
  )
}
